<template>
  <div class="_loading_10xx9_1">
    <div class="_spinner_p5ti9_1 _primary_p5ti9_35 _small_p5ti9_29"></div>
  </div>
</template>

<script>
export default {
  name: 'AbanLoading'
}
</script>
